import axios from 'axios';
if(location.hostname === 'localhost') {
    //axios.defaults.baseURL = 'http://localhost:5000/';   
    //axios.defaults.baseURL = 'https://api-code-engine-dev.dalandcuso.com/';
} else {
    //axios.defaults.baseURL = 'https://api-code-engine-dev.dalandcuso.com/';
}

//axios.defaults.baseURL = 'https://api-code-engine-dev.dalandcuso.com/';

export default {
    async getAppConfig() {
        var getUrl = "api/newconsumer/configuration";
        try {
            var response = await axios.get(getUrl, { headers: { 'Content-Type': 'application/json'} });            
            console.log('get configuration response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in get application configuration');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },

    async getPortalContent() {
        var getUrl = "api/newconsumer/portalcontent";
        try {
            var response = await axios.get(getUrl, { headers: { 'Content-Type': 'application/json'} });          
            console.log('get portal content response', response);        
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in get application contents');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },

    async getIncomeTypes() {
        var getUrl = "api/newconsumer/incometypes";
        try {
            var response = await axios.get(getUrl, { headers: { 'Content-Type': 'application/json'} });   
            console.log('get income types response', response);         
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in get income types');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },

    async parseDriversLicense(imageData) {        
        var postUrl = "api/newconsumer/parseId";
        
        var data = {};
        data.Base64IdScan = imageData.split(',')[1];

        try {
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });
            console.log('parse id response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in parse id');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },

    async getSegCompanies() {
        var getUrl = "api/newconsumer/seg"; 
        try {
            var response = await axios.get(getUrl, { headers: { 'Content-Type': 'application/json'} });          
            console.log('get seg response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in get seg companies');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },
    
    async verifyEligibility(address1, city, state, zip, isResidence, isEmployment, isSchool, isVolunteer, isWorship) {
        var postUrl = "api/newconsumer/verifyeligibility";

        var data = {};
        data.address1 = address1;
        data.city = city;
        data.state = state;
        data.zipCode = zip;
        data.isResidence = isResidence;
        data.isEmployment = isEmployment;
        data.isSchool = isSchool;
        data.isVolunteer = isVolunteer;
        data.isWorship = isWorship;
        
        try {
            console.log('verify eligibility request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });
            console.log('verify eligibility response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in verify eligibility');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },
    
    async processApplication(application) {
        var postUrl = "api/newconsumer/process";

        var data = application; 
        
        try {
            console.log('process application request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });
            console.log('process application response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in process application');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },

    async validateIpAllowed() {
        var url = "api/newconsumer/ipallowed";

        try {
            console.log('ip allowed check request');
            var response = await axios.get(url, { headers: { 'Content-Type': 'application/json'} });
            console.log('ip allowed check request', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in ip allowed check');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }        
    },

    async blocklistCheck(email, phone, ssn) {
        var postUrl = "api/newconsumer/blocklist";

        var data = {
            emailAddress: email,
            phoneNumber: phone,
            taxId: ssn
        }; 
        
        try {          
            console.log('blocklist check request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });          
            console.log('blocklist check response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in blocklist check');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },

    async validateIpDistance(address1, city, state, zipCode) {
        var postUrl = "api/newconsumer/ipdistance";

        var data = {
            address1: address1,
            city: city,
            state: state,
            zipCode: zipCode
        }; 
        
        try {
            console.log('validate ip distance request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });       
            console.log('validate ip response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in validate ip distance');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },

    async addressCheck(address1, city, state, zipCode) {
        var postUrl = "api/newconsumer/addresscheck";

        var data = {
            address1: address1,
            city: city,
            state: state,
            zipCode: zipCode
        }; 
        
        try {
            console.log('address check request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });       
            console.log('address check response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in address check');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },

    async sendEsignAgreement(emailAddress) {
        var postUrl = "api/newconsumer/esignagreement";

        var data = {
            emailAddress: emailAddress
        }; 
        
        try {
            console.info('esign agreement request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });       
            console.info('esign agreement response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in esign agreement');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },

    async getChallengeQuestions(person, address) {
        var postUrl = "api/newconsumer/challengequestion";

        var data = {
            person: person,
            address: address
        }; 
        
        try {
            console.info('get challenge questions request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });       
            console.info('get challenge questions response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in get challenge questions');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },

    async answerChallengeQuestions(questions, quizId, tranId) {
        var postUrl = "api/newconsumer/challengequestion/answer";

        var data = {
            challengeQuestions: questions,
            id: quizId,
            transactionId: tranId
        }; 
        
        try {
            console.info('answer challenge questions request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });       
            console.info('answer challenge questions response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in answer challenge questions');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },
    
    async sendMfaLink(identityVerification) {
        var postUrl = "api/newconsumer/verify/mfa";

        var data = identityVerification
        
        try {
            console.info('send mfa link request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });       
            console.info('send mfa link response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in send mfa link');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },
    
    async sendPasscode(identityVerification) {
        var postUrl = "api/newconsumer/verify/sendpasscode";

        var data = identityVerification
        
        try {
            console.info('send passcode request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });       
            console.info('send passcode response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in send passcode');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },
    
    async verifyMfaLink(identityVerification) {
        var postUrl = "api/newconsumer/verify/verify";

        var data = identityVerification
        
        try {
            console.info('verify mfa link request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });       
            console.info('verify mfa link response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in verify mfa link');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },
    
    async verifyPasscode(identityVerification) {
        var postUrl = "api/newconsumer/verify/verifypasscode";

        var data = identityVerification
        
        try {
            console.info('verify passcode request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });       
            console.info('verify passcode response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in verify passcode');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },
    
    async getVerifiedPerson(identityVerification) {
        var postUrl = "api/newconsumer/verify/getverifiedperson";

        var data = identityVerification
        
        try {
            console.info('get verified person request', data);
            var response = await axios.post(postUrl, JSON.stringify(data), { headers: { 'Content-Type': 'application/json'} });       
            console.info('get verified person response', response);
            if(response.status === 200) {
                return response.data;
            } else {
                console.error('error in get verified person');
                return null;
            }
        } catch(e) {
            console.error(e);
            return null;
        }
    },

}